// Custom Elements for Buybox

class BuyboxUsps extends HTMLElement {
  constructor() {
    super();
  }

  connectedCallback() {
    // Find all li elements within this custom element
    const listItems = this.querySelectorAll('li');

    // SVG checkmark icon
    const svgIcon = `<svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"><path d="M9 12l2 2 4-4"></path><circle cx="12" cy="12" r="10"></circle></svg>`;

    // Wrap content and prepend SVG to each li element
    listItems.forEach(li => {
      // Get the current content of the li
      const content = li.innerHTML;

      // Wrap content in a div
      const wrapper = document.createElement('div');
      wrapper.innerHTML = content;

      // Clear the li and add wrapper
      li.innerHTML = '';
      li.appendChild(wrapper);

      // Prepend SVG to li
      li.insertAdjacentHTML('afterbegin', svgIcon);
    });

    // Check if next sibling of parent .buybox-usps is .collapsible-tabs-wrapper
    const buyboxUsps = this.closest('.buybox-usps');
    if (buyboxUsps) {
      const nextSibling = buyboxUsps.nextElementSibling;
      if (nextSibling && nextSibling.classList.contains('collapsible-tabs-wrapper')) {
        buyboxUsps.classList.add('no-border');
      }
    }
  }
}

customElements.define('buybox-usps', BuyboxUsps);


class ReviewsioProductRatings extends HTMLElement {
  constructor() {
    super();
    this.observer = null;
  }

  connectedCallback() {
    // Wait for the rating snippet to be loaded
    this.waitForRatingSnippet();
  }

  waitForRatingSnippet() {
    const ratingSnippet = this.querySelector('.ruk_rating_snippet[data-done="true"]');

    if (ratingSnippet) {
      this.wrapStarIcons(ratingSnippet);
    } else {
      // Observer to watch for when the rating snippet loads
      this.observer = new MutationObserver(() => {
        const snippet = this.querySelector('.ruk_rating_snippet[data-done="true"]');
        if (snippet) {
          this.wrapStarIcons(snippet);
          this.observer.disconnect();
        }
      });

      this.observer.observe(this, {
        childList: true,
        subtree: true,
        attributes: true,
        attributeFilter: ['data-done']
      });
    }
  }

  wrapStarIcons(ratingSnippet) {
    // Find all star icon elements
    const starIcons = ratingSnippet.querySelectorAll('i[class*="ruk-icon-percentage-star"]');

    if (starIcons.length > 0) {
      // Create wrapper span
      const wrapper = document.createElement('span');
      wrapper.className = 'rating__stars';

      // Insert wrapper before the first star
      starIcons[0].parentNode.insertBefore(wrapper, starIcons[0]);

      // Move all star icons into the wrapper
      starIcons.forEach(star => {
        wrapper.appendChild(star);
      });

      // Add class to the first span sibling after stars (review count)
      const spans = ratingSnippet.querySelectorAll('span.ruk-rating-snippet-count');
      if (spans.length > 0) {
        spans[0].classList.add('rating__count');
      }

      // Add class to the last span sibling (rating number) and clean up text
      if (spans.length > 1) {
        const ratingNumberSpan = spans[1];
        ratingNumberSpan.classList.add('rating__number');

        // Keep only the <b> element, remove " / 5.00"
        const bElement = ratingNumberSpan.querySelector('b');
        if (bElement) {
          ratingNumberSpan.textContent = '';
          ratingNumberSpan.appendChild(bElement);
        }
      }
    }
  }

  disconnectedCallback() {
    if (this.observer) {
      this.observer.disconnect();
    }
  }
}

customElements.define('reviewsio-product-ratings', ReviewsioProductRatings);


class ProductCardReviewRating extends HTMLElement {
  constructor() {
    super();
    this.observer = null;
  }

  connectedCallback() {
    this.waitForWidget();
  }

  waitForWidget() {
    const ratingSnippet = this.querySelector('.ruk_rating_snippet[data-done="true"]');

    if (ratingSnippet) {
      this.processReviewCount(ratingSnippet);
    } else {
      // Observer to watch for when the widget loads
      this.observer = new MutationObserver(() => {
        const snippet = this.querySelector('.ruk_rating_snippet[data-done="true"]');
        if (snippet) {
          this.processReviewCount(snippet);
          this.observer.disconnect();
        }
      });

      this.observer.observe(this, {
        childList: true,
        subtree: true,
        attributes: true,
        attributeFilter: ['data-done']
      });
    }
  }

  processReviewCount(ratingSnippet) {
    const countSpan = ratingSnippet.querySelector('span.ruk-rating-snippet-count');

    if (countSpan) {
      // Extract only the number from the text (e.g., "8 Bewertungen" -> "(8)")
      const text = countSpan.textContent.trim();
      const numberMatch = text.match(/\d+/);

      if (numberMatch) {
        countSpan.textContent = `(${numberMatch[0]})`;
      }
    }
  }

  disconnectedCallback() {
    if (this.observer) {
      this.observer.disconnect();
    }
  }
}

customElements.define('product-card-review-rating', ProductCardReviewRating);



class ProgressBar extends HTMLElement {
  constructor() {
    super();
  }

  connectedCallback() {
  }

  disconnectedCallback() {

  }
  async fetchCart() {
    const response = await fetch('/cart.js');
    return await response.json();
  }

  async renderFreeShippingBar() {
    this.cart = await this.fetchCart();
    let total = this.cart.total_price;

    const message = this.cart.item_count > 0
      ? (total >= this.free_shipping_threshold
        ? "<p class=\"free-shipping-bar__message--free\">You are getting free gift</p>"
        : `<p>Add ${Shopify.formatMoney(this.free_shipping_threshold - total)} more for free gift</p>`)
      : '';

    const progress_bar = this.cart.item_count > 0
      ? `<div class="free-shipping-bar__progress"><div class="free-shipping-bar__progress-bar" style="width: ${Math.min((total / this.free_shipping_threshold) * 100, 100)}%;">&nbsp;</div></div>`
      : '';

    this.innerHTML = `
      <div class="free-shipping-bar__container">
        <div class="free-shipping-bar__message">
          ${message}
        </div>
        <div class="free-shipping-bar__wrapper">
          ${progress_bar}
          <div class="free-shipping-bar__threshold">
            <span>${Shopify.formatMoney(this.free_shipping_threshold, true)}</span>
          </div>
        </div>
      </div>
    `;
  }

}

customElements.define('progress-bar', ProgressBar);

class ProductBadges extends HTMLElement {
  constructor() {
    super();
    this.observer = null;
  }

  connectedCallback() {
    this.discountBadge = this.querySelector('.product-badge--discount');
    this.priceDiscountBadge = document.querySelector('.price__discount-badge');

    if (this.discountBadge && this.priceDiscountBadge) {
      // Set initial content
      this.updateDiscountBadge();

      // Set up MutationObserver to watch for changes
      this.observer = new MutationObserver(() => {
        this.updateDiscountBadge();
      });

      this.observer.observe(this.priceDiscountBadge, {
        childList: true,
        characterData: true,
        subtree: true
      });
    }
  }

  updateDiscountBadge() {
    if (this.discountBadge && this.priceDiscountBadge) {
      const content = this.priceDiscountBadge.textContent.trim();
      this.discountBadge.textContent = content;

      // Show badge if content is not empty, hide otherwise
      if (content) {
        this.discountBadge.style.display = '';
      } else {
        this.discountBadge.style.display = 'none';
      }
    }
  }

  disconnectedCallback() {
    if (this.observer) {
      this.observer.disconnect();
    }
  }
}

customElements.define('product-badges', ProductBadges);


class ManufacturerInfo extends HTMLElement {
  constructor() {
    super();
    this.manufacturerLink = this.querySelector('.manufacturer-link');
    this.tooltip = this.querySelector('.manufacturer-tooltip');
    this.closeButton = this.querySelector('.tooltip-close');
    this.isOpen = false;

    this.init();
  }

  init() {
    // Toggle tooltip on manufacturer link click
    this.manufacturerLink.addEventListener('click', (e) => {
      e.stopPropagation();
      this.toggleTooltip();
    });

    // Close tooltip on close button click
    this.closeButton.addEventListener('click', (e) => {
      e.stopPropagation();
      this.closeTooltip();
    });

    // Close tooltip when clicking outside
    document.addEventListener('click', (e) => {
      if (this.isOpen && !this.contains(e.target)) {
        this.closeTooltip();
      }
    });
  }

  toggleTooltip() {
    if (this.isOpen) {
      this.closeTooltip();
    } else {
      this.openTooltip();
    }
  }

  openTooltip() {
    this.tooltip.classList.add('is-open');
    this.isOpen = true;
  }

  closeTooltip() {
    this.tooltip.classList.remove('is-open');
    this.isOpen = false;
  }
}

customElements.define('manufacturer-info', ManufacturerInfo);


// Override Shadow DOM styles for AfterSell upsell widget
function overrideAftersellStyles() {
  const aftersellWidget = document.querySelector('#aftersell-pdp-upsell');

  if (aftersellWidget && aftersellWidget.shadowRoot) {
    const shadowRoot = aftersellWidget.shadowRoot;

    // Create style element with custom overrides
    const style = document.createElement('style');
    style.textContent = `
    .pdp-widget {
      padding-bottom: 0;
    }
      .pdp-widget .product-card-container {
        gap: 10px;
      }
    .pdp-widget .upsell-header {
      padding-bottom: 14px;
    }
      .pdp-widget .product-image-wrapper {
          align-items: start;
      }
      .pdp-widget .discounted-price-wrapper {
          align-items: center;
        }
          .pdp-widget .product-info {
          padding-bottom: 8px;
          }
        .pdp-widget .select-dropdown {
            padding: 6px 28px 6px 8px;
            text-align: left;
        }
            .pdp-widget select {
              height: 27px;
            }
      .pdp-widget .add-button {
        height: 32px;
    }
        @media (min-width: 1024px) {
          .pdp-widget .product-card-container {
            gap: 14px;
          }
          .pdp-widget .upsell-header {
              padding-bottom: 20px;
              font-size: 18px;
          }
              .pdp-widget .product-card.vertical {
                padding: 14px;
              }
            .pdp-widget .product-card {
              gap: 14px;
            }
          .pdp-widget .product-image {
            width: 76px;
            height: 76px;
          }
        .pdp-widget .product-title {
          font-size: 13px;
        }
        .pdp-widget .discount-label {
          font-size: 12px;
        }
        .pdp-widget .price-info {
          font-size: 14px;
        }
        .pdp-widget .price-info.compare-at-price {
          font-size: 12px;
        }
        .pdp-widget .select-dropdown {
            font-size: 12px;
    padding: 7px 30px 7px 10px;
        }
        .pdp-widget .add-button {
          height: 34px;  
        padding: 9px 16px;
          font-size: 12px;
        }
        }
    `;

    // Inject the style into shadow root
    shadowRoot.appendChild(style);
  }
}

// Run when DOM is ready
if (document.readyState === 'loading') {
  document.addEventListener('DOMContentLoaded', () => {
    setTimeout(overrideAftersellStyles, 500);
  });
} else {
  setTimeout(overrideAftersellStyles, 500);
}

// Also observe for dynamic insertion
const observer = new MutationObserver(() => {
  const aftersellWidget = document.querySelector('#aftersell-pdp-upsell');
  if (aftersellWidget && aftersellWidget.shadowRoot) {
    overrideAftersellStyles();
    observer.disconnect();
  }
});

observer.observe(document.body, {
  childList: true,
  subtree: true
});
